// // ===== AGB BUNDLES MODULE =====
// // Bundle configuration and helpers to translate option selections into base + accepted items
// AGB.define('bundles', ['core', 'store'], function (Core, Store) {
//     const { scheduler } = Core;

//     // ================= CONFIG =================
//     // Public, editable lists (extend in theme editor if needed)
//     const bundleList = [
//         'k-zero-bundle',
//         'k-zero-test-bundle',
//         'k-zero-sf-bundle',
//         'k-zero-plate-carrier-with-level-4-plates-2-x-level-4-warrior-plates',
//         'k-zero-sf-plate-carrier-with-plates-2-x-level-3st-protector-plates',
//         'k-zero-sf-plate-carrier-with-level-4-plates-2-x-level-4-warrior-plates',
//         'sub-zero-plate-carrier-with-2-protector-level-3st-armor-plates',
//         'k-zero-plate-carrier-with-plates-level-3st',
//         'reaper-rig-micro-rig-bundle'
//     ];

//     // Fix the syntax errors in the BUNDLE_DATA object
//     const BUNDLE_DATA = {
//         'k-zero-bundle': {
//             // Defaults for base item options that are not chosen by user
//             // Example: ensure base size is Medium unless user selects otherwise
//             defaults: {
//                 'k-zero-plate-carrier': { option2: 'Medium (10x12 or SAPI Medium)' }
//             },
//             // Map Shopify optionN to handles
//             // option1 is base item; option2+ become accepted items
//             optionToHandle: {
//                 option1: 'k-zero-plate-carrier',
//                 option2: 'pincer-placard',
//                 option3: 'six-pack-hanger-pouch'
//             }
//         },
//         'k-zero-test-bundle': {
//             // Defaults for base item options that are not chosen by user
//             // Example: ensure base size is Medium unless user selects otherwise
//             defaults: {
//                 'k-zero-plate-carrier-copy': { option2: 'Medium (10x12 or SAPI Medium)' }
//             },
//             // Map Shopify optionN to handles
//             // option1 is base item; option2+ become accepted items
//             optionToHandle: {
//                 option1: 'k-zero-plate-carrier',
//                 option2: 'pincer-placard',
//                 option3: 'six-pack-hanger-pouch'
//             }
//         },
//         'k-zero-sf-bundle': {
//             // Defaults for base item options that are not chosen by user
//             // Example: ensure base size is Medium unless user selects otherwise
//             defaults: {
//                 'k-zero-sf-plate-carrier': { }
//             },
//             // Map Shopify optionN to handles
//             // option1 is base item; option2+ become accepted items
//             optionToHandle: {
//                 option1: 'k-zero-sf-plate-carrier',
//                 option2: 'pincer-placard',
//                 option3: 'six-pack-hanger-pouch'
//             }
//         },

//         'k-zero-plate-carrier-with-level-4-plates-2-x-level-4-warrior-plates': {
//             defaults: {
//                 'k-zero-plate-carrier': { option2: 'Medium (10x12 or SAPI Medium)' }
//             },
//             optionToHandle: {
//                 option1: 'k-zero-plate-carrier'
//             }
//         },

//         'k-zero-plate-carrier-with-plates-level-3st': {
//             defaults: {
//                 'k-zero-plate-carrier': { option2: 'Medium (10x12 or SAPI Medium)' }
//             },
//             optionToHandle: {
//                 option1: 'k-zero-plate-carrier'
//             }
//         },

//         'k-zero-sf-plate-carrier-with-level-4-plates-2-x-level-4-warrior-plates': {
//             defaults: {
//                 'k-zero-sf-plate-carrier': { option2: 'Medium (10x12 or SAPI Medium)' }
//             },
//             optionToHandle: {
//                 option1: 'k-zero-sf-plate-carrier'
//             }
//         },

//         'k-zero-sf-plate-carrier-with-plates-2-x-level-3st-protector-plates': {
//             defaults: {
//                 'k-zero-sf-plate-carrier': { }
//             },
//             optionToHandle: {
//                 option1: 'k-zero-sf-plate-carrier'
//             }
//         },

//         'sub-zero-plate-carrier-with-2-protector-level-3st-armor-plates': {
//             defaults: {
//                 'sub-zero-plate-carrier': { option2: 'Medium' }
//             },
//             optionToHandle: {
//                 option1: 'sub-zero-plate-carrier'
//             }
//         },

//         'reaper-rig-micro-rig-bundle': {
//             defaults: {
//             },
//             optionToHandle: {
//                 option1: 'reaper-chest-rig',
//                 option2: 'pincer-placard',
//                 option3: 'six-pack-hanger-pouch'
//             }
//         }
//     };

//     // ================= Helpers =================
//     const ProductCache = new Map();

//     async function fetchProductByHandle(handle) {
//         if (!handle) return null;
//         if (ProductCache.has(handle)) return ProductCache.get(handle);
//         try {
//             const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
//             if (!res.ok) return null;
//             const data = await res.json();
//             ProductCache.set(handle, data);
//             return data;
//         } catch {
//             return null;
//         }
//     }

//     function findColorOptionIndex(product) {
//         try {
//             const options = Array.isArray(product?.options) ? product.options : [];
//             // options may be strings or objects with name
//             const names = options.map(o => (typeof o === 'string' ? o : o?.name || '') + '');
//             const idx = names.findIndex(n => /color/i.test(String(n)));
//             return idx === -1 ? 0 : idx;
//         } catch {
//             return 0;
//         }
//     }

//     function pickVariantForColor(product, color) {
//         if (!product || !Array.isArray(product.variants)) return null;
//         const colorIdx = findColorOptionIndex(product);
//         const normalize = (s) => String(s || '').trim().toLowerCase();
//         const desired = normalize(color);

//         // Prefer available variant with exact color match
//         let v = product.variants.find(vari => normalize(vari.options?.[colorIdx]) === desired && vari.available);
//         if (v) return v;
//         // Fallback to any variant with color match
//         v = product.variants.find(vari => normalize(vari.options?.[colorIdx]) === desired);
//         if (v) return v;
//         // Fallback to first available
//         v = product.variants.find(vari => vari.available);
//         if (v) return v;
//         // Fallback to first
//         return product.variants[0] || null;
//     }

//     function isBundle(handle) {
//         return bundleList.includes(String(handle || ''));
//     }

//     // Build mapping from product variant options to bundle handles
//     function mapOptionIndexToHandle(productHandle) {
//         const spec = BUNDLE_DATA[productHandle];
//         if (!spec || !spec.optionToHandle) return {};
//         const out = {};
//         for (const [optKey, handle] of Object.entries(spec.optionToHandle)) {
//             const m = optKey.match(/^option(\d+)$/i);
//             if (!m) continue;
//             const idx = parseInt(m[1], 10) - 1; // 0-based index
//             if (idx >= 0) out[idx] = handle;
//         }
//         return out; // { 0: 'baseHandle', 1: '...', 2: '...' }
//     }

//     // Resolve base + accepted from the bundle variant selection
//     async function resolveBundleFromVariant(product, variant) {
//         try {
//             if (!product || !variant) return null;
//             const handle = product.handle;
//             if (!isBundle(handle)) return null;

//             const spec = BUNDLE_DATA[handle] || {};
//             const optionMap = mapOptionIndexToHandle(handle);
//             const chosen = Array.isArray(variant.options) ? variant.options : [];

//             // Base
//             const baseIdx = 0; // option1
//             const baseHandle = optionMap[baseIdx];
//             const baseColor = chosen[baseIdx] || '';

//             let baseItem = null;
//             if (baseHandle) {
//                 const baseProduct = await fetchProductByHandle(baseHandle);
//                 const baseVariant = pickVariantForColor(baseProduct, baseColor);

//                 // Apply defaults if provided
//                 const defaults = (spec.defaults && spec.defaults[baseHandle]) || null;

//                 baseItem = {
//                     handle: baseHandle,
//                     id: baseVariant?.id || null,
//                     sku: baseVariant?.sku || null,
//                     color: baseColor || (baseVariant?.options?.[findColorOptionIndex(baseProduct)] || null),
//                     size: defaults?.option2 || baseVariant?.options?.[1] || null,
//                     price: variant ? (Number(variant.price) / 100).toFixed(2) : null,
//                     available: !!baseVariant?.available,
//                     image: baseVariant?.featured_image?.src || baseProduct?.featured_image || null,
//                     qty: 1,
//                     title: baseProduct?.title || baseHandle
//                 };
//             }

//             // Accepted items (option2+)
//             const acceptedItems = [];
//             for (let i = 1; i < chosen.length; i++) {
//                 const itemHandle = optionMap[i];
//                 if (!itemHandle) continue;
//                 const color = chosen[i];

//                 const prod = await fetchProductByHandle(itemHandle);
//                 const v = pickVariantForColor(prod, color);
//                 if (!v) continue;

//                 acceptedItems.push({
//                     handle: itemHandle,
//                     id: v.id,
//                     variantId: v.id,
//                     variantColor: color,
//                     color: color,
//                     price: (Number(v.price) / 100).toFixed(2),
//                     qty: 1,
//                     title: prod?.title || itemHandle,
//                     ghost: true // bundle-included component (UI can hide/skip rendering)
//                 });
//             }

//             return { baseItem, acceptedItems };
//         } catch {
//             return null;
//         }
//     }

//     function replaceAcceptedByHandles(state, items) {
//         const handlesToReplace = new Set(items.map(it => it.handle));
//         const keep = Array.isArray(state.acceptedItems) ? state.acceptedItems.filter(it => !handlesToReplace.has(it?.handle)) : [];
//         return keep.concat(items);
//     }

//     // Drop-in replacement
//     function applyBundleToStore(result) {
//         if (!result) return;

//         // Global re-entrancy guard so bundle apply won't trigger itself again
//         window.__AGB_APPLYING_BUNDLE__ = window.__AGB_APPLYING_BUNDLE__ || false;
//         if (window.__AGB_APPLYING_BUNDLE__) return;

//         window.__AGB_APPLYING_BUNDLE__ = true;
//         try {
//             const { baseItem, acceptedItems } = result;

//             // Update Store atomically
//             Store.mutate((state) => {
//                 if (baseItem) {
//                     state.baseItem = Object.assign(state.baseItem || {}, baseItem);
//                 }
//                 if (Array.isArray(acceptedItems)) {
//                     // keep your existing helper to align handles -> accepted list
//                     state.acceptedItems = replaceAcceptedByHandles(state, acceptedItems);
//                 }
//             });

//             // Keep legacy globals in sync (if any UI still relies on them)
//             try {
//                 const st = Store.getState();
//                 if (st?.baseItem) window.baseItem = st.baseItem;
//                 if (Array.isArray(st?.acceptedItems)) window.acceptedItems = st.acceptedItems;
//             } catch (_) { }

//             // Notify UI (these used to cause loops -> now safe due to the guard)
//             try { document.dispatchEvent(new CustomEvent('baseItemChanged')); } catch (_) { }
//             try { document.dispatchEvent(new CustomEvent('acceptedItemsChanged')); } catch (_) { }

//             // Kick scheduled systems
//             try {
//                 scheduler?.mark?.('pricing');
//                 scheduler?.mark?.('ui');
//                 scheduler?.mark?.('canvas');
//                 scheduler?.mark?.('sticky');
//             } catch (_) { }

//         } catch (_) {
//             // swallow – keep UX resilient
//         } finally {
//             // release on next tick so listeners finish without re-entering immediately
//             setTimeout(() => { window.__AGB_APPLYING_BUNDLE__ = false; }, 0);
//         }
//     }


//     // Public API
//     return {
//         bundleList,
//         BUNDLE_DATA,
//         isBundle,
//         resolveBundleFromVariant,
//         applyBundleToStore
//     };
// });


// ===== AGB BUNDLES MODULE =====
// Bundle configuration and helpers to translate option selections into base + accepted items
AGB.define('bundles', ['core', 'store', 'store-config'], function (Core, Store, StoreConfig) {
    const { scheduler } = Core;

    function getLocalizedProductJsonUrl(handle) {
        const root = String(window?.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
        return `${root}products/${encodeURIComponent(handle)}.js`;
    }

    // ================= CONFIG =================
    // Public, editable lists (extend in theme editor if needed)
    const bundleListRaw = [
        'k-zero-bundle',
        'k-zero-test-bundle',
        'k-zero-sf-bundle',
        'k-zero-plate-carrier-with-level-4-plates-2-x-level-4-warrior-plates',
        'k-zero-sf-plate-carrier-with-plates-2-x-level-3st-protector-plates',
        'k-zero-sf-plate-carrier-with-level-4-plates-2-x-level-4-warrior-plates',
        'sub-zero-plate-carrier-with-2-protector-level-3st-armor-plates',
        'k-zero-plate-carrier-with-plates-level-3st',
        'reaper-rig-micro-rig-bundle',
        'sub-zero-ranger-green-bundle',
        'sub-zero-multicam-bundle',
        'sub-zero-black-bundle'
    ];
    
    // Map bundle list to store-specific handles
    const bundleList = StoreConfig.mapHandles(bundleListRaw);

    // Fix the syntax errors in the BUNDLE_DATA object
    // Note: BUNDLE_DATA uses US handles as source of truth, will be mapped at runtime
    const BUNDLE_DATA_RAW = {
        'k-zero-bundle': {
            // Defaults for base item options that are not chosen by user
            // Example: ensure base size is Medium unless user selects otherwise
            defaults: {
                'k-zero-plate-carrier': { option2: 'Medium (10x12 or SAPI Medium)' }
            },
            // Included accessories come from includedItems (coloured to the
            // carrier's chosen colour), NOT optionToHandle option2/3: the live
            // bundle PRODUCT has no per-accessory option columns, so the
            // option-driven loop added nothing and the canvas showed only the
            // bare carrier. includedItems is the same robust path the sub-zero
            // bundles use; the components are added as ghost layers (drawn on
            // the canvas, excluded from add-to-cart). option1 = the carrier.
            includedItems: ['pincer-placard', 'six-pack-hanger-pouch'],
            optionToHandle: {
                option1: 'k-zero-plate-carrier'
            }
        },
        'k-zero-test-bundle': {
            // Defaults for base item options that are not chosen by user
            // Example: ensure base size is Medium unless user selects otherwise
            defaults: {
                'k-zero-plate-carrier-copy': { option2: 'Medium (10x12 or SAPI Medium)' }
            },
            // Map Shopify optionN to handles
            // option1 is base item; option2+ become accepted items
            optionToHandle: {
                option1: 'k-zero-plate-carrier',
                option2: 'pincer-placard',
                option3: 'six-pack-hanger-pouch'
            }
        },
        'k-zero-sf-bundle': {
            // Defaults for base item options that are not chosen by user
            // Example: ensure base size is Medium unless user selects otherwise
            defaults: {
                'k-zero-sf-plate-carrier': { }
            },
            // includedItems (not optionToHandle option2/3) — see k-zero-bundle:
            // the live product lacks per-accessory option columns, so the
            // option-driven loop added nothing. Ghost layers, carrier-coloured.
            includedItems: ['pincer-placard', 'six-pack-hanger-pouch'],
            optionToHandle: {
                option1: 'k-zero-sf-plate-carrier'
            }
        },

        'k-zero-plate-carrier-with-level-4-plates-2-x-level-4-warrior-plates': {
            defaults: {
                'k-zero-plate-carrier': { option2: 'Medium (10x12 or SAPI Medium)' }
            },
            optionToHandle: {
                option1: 'k-zero-plate-carrier'
            }
        },

        'k-zero-plate-carrier-with-plates-level-3st': {
            defaults: {
                'k-zero-plate-carrier': { option2: 'Medium (10x12 or SAPI Medium)' }
            },
            optionToHandle: {
                option1: 'k-zero-plate-carrier'
            }
        },

        'k-zero-sf-plate-carrier-with-level-4-plates-2-x-level-4-warrior-plates': {
            defaults: {
                'k-zero-sf-plate-carrier': { option2: 'Medium (10x12 or SAPI Medium)' }
            },
            optionToHandle: {
                option1: 'k-zero-sf-plate-carrier'
            }
        },

        'k-zero-sf-plate-carrier-with-plates-2-x-level-3st-protector-plates': {
            defaults: {
                'k-zero-sf-plate-carrier': { }
            },
            optionToHandle: {
                option1: 'k-zero-sf-plate-carrier'
            }
        },

        'sub-zero-plate-carrier-with-2-protector-level-3st-armor-plates': {
            defaults: {
                'sub-zero-plate-carrier': { option2: 'Medium' }
            },
            optionToHandle: {
                option1: 'sub-zero-plate-carrier'
            }
        },

        'reaper-rig-micro-rig-bundle': {
            defaults: {
            },
            // includedItems (not optionToHandle option2/3) — see k-zero-bundle:
            // the live product lacks per-accessory option columns, so the
            // option-driven loop added nothing. Ghost layers, carrier-coloured.
            includedItems: ['pincer-placard', 'six-pack-hanger-pouch'],
            optionToHandle: {
                option1: 'reaper-chest-rig'
            }
        },

        'sub-zero-ranger-green-bundle': {
            fixedColor: 'Ranger Green',
            includedItems: ['ag3-placard-triple-mag-pouch', 'six-pack-hanger-pouch'],
            defaults: {},
            optionToHandle: {
                option1: 'sub-zero-plate-carrier'
            }
        },
        'sub-zero-multicam-bundle': {
            fixedColor: 'Multicam',
            includedItems: ['ag3-placard-triple-mag-pouch', 'wide-admin-pouch'],
            defaults: {},
            optionToHandle: {
                option1: 'sub-zero-plate-carrier'
            }
        },
        'sub-zero-black-bundle': {
            fixedColor: 'Black',
            includedItems: ['ag3-placard-triple-mag-pouch', 'six-pack-hanger-pouch'],
            defaults: {},
            optionToHandle: {
                option1: 'sub-zero-plate-carrier'
            }
        }
    };

    // Map BUNDLE_DATA to store-specific handles
    const BUNDLE_DATA = StoreConfig.mapObjectKeys(
        Object.fromEntries(
            Object.entries(BUNDLE_DATA_RAW).map(([bundleHandle, spec]) => {
                const mappedBundleHandle = StoreConfig.mapHandle(bundleHandle);
                const mappedSpec = {
                    ...spec,
                    optionToHandle: spec.optionToHandle ? Object.fromEntries(
                        Object.entries(spec.optionToHandle).map(([opt, handle]) => [
                            opt,
                            StoreConfig.mapHandle(handle)
                        ])
                    ) : {},
                    defaults: spec.defaults ? Object.fromEntries(
                        Object.entries(spec.defaults).map(([handle, defaults]) => [
                            StoreConfig.mapHandle(handle),
                            defaults
                        ])
                    ) : {},
                    includedItems: spec.includedItems
                        ? spec.includedItems.map(h => StoreConfig.mapHandle(h))
                        : undefined,
                    fixedColor: spec.fixedColor || undefined
                };
                return [mappedBundleHandle, mappedSpec];
            })
        )
    );

    // ================= Helpers =================
    const ProductCache = new Map();

    async function fetchProductByHandle(handle) {
        if (!handle) return null;
        if (ProductCache.has(handle)) return ProductCache.get(handle);
        try {
            const res = await fetch(getLocalizedProductJsonUrl(handle), { headers: { Accept: 'application/json' } });
            if (!res.ok) return null;
            const data = await res.json();
            ProductCache.set(handle, data);
            return data;
        } catch {
            return null;
        }
    }

    function findColorOptionIndex(product) {
        try {
            const options = Array.isArray(product?.options) ? product.options : [];
            // options may be strings or objects with name
            const names = options.map(o => (typeof o === 'string' ? o : o?.name || '') + '');
            const idx = names.findIndex(n => /color/i.test(String(n)));
            return idx === -1 ? 0 : idx;
        } catch {
            return 0;
        }
    }

    function pickVariantForColor(product, color) {
        if (!product || !Array.isArray(product.variants)) return null;
        const colorIdx = findColorOptionIndex(product);
        const normalize = (s) => String(s || '').trim().toLowerCase();
        const desired = normalize(color);

        // Prefer available variant with exact color match
        let v = product.variants.find(vari => normalize(vari.options?.[colorIdx]) === desired && vari.available);
        if (v) return v;
        // Fallback to any variant with color match
        v = product.variants.find(vari => normalize(vari.options?.[colorIdx]) === desired);
        if (v) return v;
        // Fallback to first available
        v = product.variants.find(vari => vari.available);
        if (v) return v;
        // Fallback to first
        return product.variants[0] || null;
    }

    function isBundle(handle) {
        // Map handle for comparison
        const mappedHandle = StoreConfig.mapHandle(String(handle || ''));
        return bundleList.includes(mappedHandle);
    }

    // Build mapping from product variant options to bundle handles
    function mapOptionIndexToHandle(productHandle) {
        const spec = BUNDLE_DATA[productHandle];
        if (!spec || !spec.optionToHandle) return {};
        const out = {};
        for (const [optKey, handle] of Object.entries(spec.optionToHandle)) {
            const m = optKey.match(/^option(\d+)$/i);
            if (!m) continue;
            const idx = parseInt(m[1], 10) - 1; // 0-based index
            if (idx >= 0) out[idx] = handle;
        }
        return out; // { 0: 'baseHandle', 1: '...', 2: '...' }
    }

    // Resolve base + accepted from the bundle variant selection
    async function resolveBundleFromVariant(product, variant) {
        try {
            if (!product || !variant) return null;
            const handle = product.handle;
            if (!isBundle(handle)) return null;

            const spec = BUNDLE_DATA[handle] || {};
            const optionMap = mapOptionIndexToHandle(handle);
            const chosen = Array.isArray(variant.options) ? variant.options : [];

            // Base
            const baseIdx = 0; // option1
            const baseHandle = optionMap[baseIdx];

            // Fixed-color bundles: color comes from spec, option1 is the size
            const hasFixedColor = !!spec.fixedColor;
            const baseColor = hasFixedColor ? spec.fixedColor : (chosen[baseIdx] || '');
            const baseSize = hasFixedColor ? (chosen[0] || '') : null;

            let baseItem = null;
            if (baseHandle) {
                const baseProduct = await fetchProductByHandle(baseHandle);

                // Pick variant: for fixed-color bundles match both color AND size
                let baseVariant;
                if (hasFixedColor && baseSize && baseProduct) {
                    const colorIdx = findColorOptionIndex(baseProduct);
                    const sizeIdx = colorIdx === 0 ? 1 : 0;
                    const normalize = (s) => String(s || '').trim().toLowerCase();
                    baseVariant = baseProduct.variants.find(v =>
                        normalize(v.options?.[colorIdx]) === normalize(baseColor)
                        && normalize(v.options?.[sizeIdx]) === normalize(baseSize)
                        && v.available
                    ) || baseProduct.variants.find(v =>
                        normalize(v.options?.[colorIdx]) === normalize(baseColor)
                        && normalize(v.options?.[sizeIdx]) === normalize(baseSize)
                    ) || pickVariantForColor(baseProduct, baseColor);
                } else {
                    baseVariant = pickVariantForColor(baseProduct, baseColor);
                }

                // Apply defaults if provided
                const defaults = (spec.defaults && spec.defaults[baseHandle]) || null;

                baseItem = {
                    handle: baseHandle,
                    id: baseVariant?.id || null,
                    sku: baseVariant?.sku || null,
                    color: baseColor || (baseVariant?.options?.[findColorOptionIndex(baseProduct)] || null),
                    size: hasFixedColor
                        ? (baseSize || baseVariant?.options?.[1] || null)
                        : (defaults?.option2 || baseVariant?.options?.[1] || null),
                    price: variant ? (Number(variant.price) / 100).toFixed(2) : null,
                    available: !!baseVariant?.available,
                    image: baseVariant?.featured_image?.src || baseProduct?.featured_image || null,
                    qty: 1,
                    title: baseProduct?.title || baseHandle
                };
            }

            // Accepted items (option2+)
            const acceptedItems = [];
            for (let i = 1; i < chosen.length; i++) {
                const itemHandle = optionMap[i];
                if (!itemHandle) continue;
                const color = chosen[i];

                const prod = await fetchProductByHandle(itemHandle);
                const v = pickVariantForColor(prod, color);
                if (!v) continue;

                acceptedItems.push({
                    handle: itemHandle,
                    id: v.id,
                    variantId: v.id,
                    variantColor: color,
                    color: color,
                    price: (Number(v.price) / 100).toFixed(2),
                    qty: 1,
                    title: prod?.title || itemHandle,
                    ghost: true // bundle-included component (UI can hide/skip rendering)
                });
            }

            // Pre-included items from the bundle spec. Colour them to the
            // carrier's RESOLVED colour (baseItem.color), NOT the raw baseColor:
            // for non-fixedColor bundles (k-zero / k-zero-sf / reaper) baseColor
            // is variant.options[0], which can be a size or blank when option1
            // isn't the colour — that would fail pickVariantForColor and silently
            // drop the component (the original bug). baseItem.color already
            // carries the colour-option fallback; for fixedColor bundles the two
            // are identical, so this is a no-op there.
            if (Array.isArray(spec.includedItems)) {
                const incColor = (baseItem && baseItem.color) || baseColor;
                for (const itemHandle of spec.includedItems) {
                    const prod = await fetchProductByHandle(itemHandle);
                    const v = pickVariantForColor(prod, incColor);
                    if (!v) continue;

                    acceptedItems.push({
                        handle: itemHandle,
                        id: v.id,
                        variantId: v.id,
                        variantColor: incColor,
                        color: incColor,
                        price: (Number(v.price) / 100).toFixed(2),
                        qty: 1,
                        title: prod?.title || itemHandle,
                        ghost: true
                    });
                }
            }

            return { baseItem, acceptedItems };
        } catch {
            return null;
        }
    }

    function replaceAcceptedByHandles(state, items) {
        const handlesToReplace = new Set(items.map(it => it.handle));
        const keep = Array.isArray(state.acceptedItems) ? state.acceptedItems.filter(it => !handlesToReplace.has(it?.handle)) : [];
        return keep.concat(items);
    }

    // Drop-in replacement
    function applyBundleToStore(result) {
        if (!result) return;

        // Global re-entrancy guard so bundle apply won't trigger itself again
        window.__AGB_APPLYING_BUNDLE__ = window.__AGB_APPLYING_BUNDLE__ || false;
        if (window.__AGB_APPLYING_BUNDLE__) return;

        window.__AGB_APPLYING_BUNDLE__ = true;
        try {
            const { baseItem, acceptedItems } = result;

            // Update Store atomically
            Store.mutate((state) => {
                if (baseItem) {
                    state.baseItem = Object.assign(state.baseItem || {}, baseItem);
                }
                if (Array.isArray(acceptedItems)) {
                    // keep your existing helper to align handles -> accepted list
                    state.acceptedItems = replaceAcceptedByHandles(state, acceptedItems);
                }
            });

            // Keep legacy globals in sync (if any UI still relies on them)
            try {
                const st = Store.getState();
                if (st?.baseItem) window.baseItem = st.baseItem;
                if (Array.isArray(st?.acceptedItems)) window.acceptedItems = st.acceptedItems;
            } catch (_) { }

            // Notify UI (these used to cause loops -> now safe due to the guard)
            try { document.dispatchEvent(new CustomEvent('baseItemChanged')); } catch (_) { }
            try { document.dispatchEvent(new CustomEvent('acceptedItemsChanged')); } catch (_) { }

            // Emit acceptedItemsChanged on the AGB bus so the suggest module
            // updates card accepted-states (lightweight updateCardStates, not
            // a full renderNext). resolveVariant already handles baseItemChanged
            // with the correct color via bundleAwareColorSize, so we do NOT
            // emit baseItemChanged here – doing so races with the agb:step2
            // handler and doubles the suggestion cards.
            try { Core.bus.emit('acceptedItemsChanged'); } catch (_) { }

            // Kick scheduled systems
            try {
                scheduler?.mark?.('pricing');
                scheduler?.mark?.('ui');
                scheduler?.mark?.('canvas');
                scheduler?.mark?.('sticky');
            } catch (_) { }

        } catch (_) {
            // swallow – keep UX resilient
        } finally {
            // release on next tick so listeners finish without re-entering immediately
            setTimeout(() => { window.__AGB_APPLYING_BUNDLE__ = false; }, 0);
        }
    }


    // Public API
    return {
        bundleList,
        BUNDLE_DATA,
        isBundle,
        resolveBundleFromVariant,
        applyBundleToStore
    };
});


